import { createContext } from "react"
import type { ThemeMode } from "./mode"

export interface ThemeModeContextValue {
  /** The mode being drawn right now — always resolved, never "system". */
  readonly mode: ThemeMode
  /**
   * Whether `mode` came from the user rather than from the OS. False means the
   * app is still following `prefers-color-scheme` and will keep following it.
   */
  readonly isExplicit: boolean
  readonly setMode: (mode: ThemeMode) => void
  readonly toggle: () => void
  /** Hands the decision back to the OS, forgetting the stored choice. */
  readonly followSystem: () => void
}

export const ThemeModeContext = createContext<ThemeModeContextValue | undefined>(undefined)
